import { Box } from '@mui/material';

const AssignPreventorCardContainer = ({ children }: { children: React.ReactNode }) => (
    <Box
        sx={{
            backgroundColor: '#F3F8F8',
            borderRadius: '8px',
            padding: '16px'
        }}
    >
        {children}
    </Box>
);

export { AssignPreventorCardContainer };
